import { getState, patchState, signalStoreFeature, withHooks, withMethods, withState } from '@ngrx/signals';
import { effect } from '@angular/core';

// Consider this enhancement in the future, even if it is manually pulled in
//     Specify subset of state
// https://github.com/gabrielguerrero/ngrx-traits/blob/c2e95fee006134286cb7a031aff55b9da0aa128a/apps/example-app/src/app/examples/signals/product-shop-page/products-shop.store.ts#L103
export function withLogger(name: string) {
    return signalStoreFeature(
        withHooks({
            onInit(store) {
                effect(() => {
                    const state = getState(store);
                    console.log(`${name} state changed`, state);
                });
            },
        })
    );
}

export function withLoading<_>() {
    return signalStoreFeature(
        withState({ loading: false }),
        withMethods(state => ({
            setLoading(value: boolean) {
                patchState(state, { loading: value });
            },
        }))
    );
}
